import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NbAuthJWTToken, NbAuthService, NbTokenService } from '@nebular/auth';
import { Observable } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExternalAuthorizeGuard  {
  constructor(private nbAuthService: NbAuthService, private tokenService: NbTokenService) { }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.nbAuthService.isAuthenticated().pipe(
      tap(x => {
        if (x)
          window.open(environment.sloUrl);
      }),
      map(() => {
        if (childRoute.queryParams.token) {
          this.tokenService.set(new NbAuthJWTToken(childRoute.queryParams.token, 'email'));
          return true;
        }
        return false;
      })
    );
  }
}
